import React from 'react'
import DocumentTitle from 'react-document-title'
import Spinner from 'react-spinkit'
import notifs from '../http/notifs'
import pings from '../http/pings'
import timeago from 'timeago.js'

class SortableDateAgo {
  constructor (date) {
    this.value = date
    this.time = new Date(date).getTime()
  }
  toString() {
    return new timeago().format(this.time)
  }
  getTime() {
    return this.time
  }
}

export default class NotifsPage extends React.Component {
  constructor (props){
    super(props)

    this.state = {
      loading: false,
      notifsList: [],
    }
  }

  componentDidMount() {
    this.setState({
      loading: true,
    })
    this.checkpoint()
    this.fetch()
  }

  checkpoint() {
    pings.set('notifs', (result) => {})
    pings.get('notifs', (previousVisit) => {
      localStorage.setItem('pingNotifs', previousVisit)
    })
  }

  showNotifs(results) {
    this.setState({
      notifsList: results,
      loading: false,
    })
  }

  fetch() {
    notifs.fetch((results) => {
      let cleanedResults = results.map((result) => ({
        title: result.title,
        category: result.category,
        date: new SortableDateAgo(result.date * 1000),
      }))
      cleanedResults.sort((a, b) => a.date.getTime() > b.date.getTime() ? -1 : 1)
      this.showNotifs(cleanedResults)
    })
  }

  renderList( list ) {
    let previousVisit = localStorage.getItem('pingNotifs')
    const rows = list.map((row) => {
      if (row.date.getTime() >= previousVisit * 1000 ) {
        return (
          <li className="list-group-item active col-xs-12" key={'notif-' + row.date.getTime()}>
            <p className='col-xs-2'>{row.date.toString()}</p>
            <p className='col-xs-2'>{row.category}</p>
            <p className='col-xs-8 pull-right'>{row.title}</p>
          </li>
        )
      } else {
        return (
          <li className="list-group-item col-xs-12" key={'notif-' + row.date.getTime()}>
            <p className='col-xs-2'>{row.date.toString()}</p>
            <p className='col-xs-2'>{row.category}</p>
            <p className='col-xs-8 pull-right'>{row.title}</p>
          </li>
        )
      }
    })
    return rows
  }

  render() {
    let notifsList = this.state.notifsList
    return (
      <DocumentTitle title={'Café App'}>
      <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h3>Notifications {this.state.loading ? <Spinner spinnerName="three-bounce" className="col-xs-1 pull-right" noFadeIn /> : ''}</h3>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <ul className="list-group">{ this.renderList(notifsList) }</ul>
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/NotifsPage.js